import React from 'react';

/* Ported from the waifu-briscola game lib (ui/Button, ui/ModalHeader, ui/WaifuTile, ui/GameIcons).
   Same variants/tones/sizes, plain CSS instead of Tailwind + framer-motion. */

export const Sym = ({ name, size = 24, fill = false, style }) => (
  <span aria-hidden="true" className={'ms' + (fill ? ' fill' : '')} style={{ fontSize: size, ...style }}>{name}</span>
);

export const Svg = ({ d, size = 20, ...rest }) => (
  <svg width={size} height={size} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" {...rest}><path d={d} /></svg>
);

export const Button = ({ variant = 'primary', size = 'md', fullWidth = false, className = '', children, ...rest }) => (
  <button type="button" className={['btn', variant, size, fullWidth ? 'full' : '', className].filter(Boolean).join(' ')} {...rest}>{children}</button>
);

export const ModalHeader = ({ tone = 'brand', icon, title, subtitle }) => (
  <div className="mh">
    {icon && <span className={'mh-icon ' + tone}><Sym name={icon} /></span>}
    <div style={{ flex: 1, minWidth: 0 }}>
      {title && <h3 className="mh-title">{title}</h3>}
      {subtitle && <p className="mh-sub">{subtitle}</p>}
    </div>
  </div>
);

export const WaifuTile = ({ waifu, selected = false, isSafeMode = false, onClick }) => (
  <button type="button" onClick={onClick} aria-label={waifu.name} aria-pressed={selected} className={'tile' + (selected ? ' selected' : '')}>
    <span className="tile-img" style={{ background: waifu.theme }}>
      {isSafeMode ? <Sym name="person" size={26} fill /> : <img src={waifu.imageUrl} alt="" loading="lazy" decoding="async" />}
    </span>
    <span className="tile-name">{waifu.name}</span>
    <span className="bar" style={{ background: 'linear-gradient(90deg, transparent, ' + waifu.theme + ', transparent)' }} />
  </button>
);

const Stroke = ({ children }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{children}</svg>
);

const MODE_ICONS = {
  Classic: <Stroke><path d="M4.2 18.6 2.9 8.1l4.7 3.2L12 4.2l4.4 7.1 4.7-3.2-1.3 10.5z" /><path d="M4.2 18.6h15.6" /><circle cx="12" cy="13.6" r="1.5" fill="currentColor" stroke="none" /></Stroke>,
  Puzzle: <Stroke><path d="M4.2 4.2h5.1a2 2 0 1 1 3.9 0h6.6v6.6a2 2 0 1 0 0 3.9v5.1H4.2z" /></Stroke>,
  Roguelike: <Stroke><path d="M5.4 18.2 9 12.4l-2.4-5.2M9 12.4l6-1.8 3.6-4.6" opacity=".55" /><circle cx="5.4" cy="18.6" r="1.9" /><circle cx="6.4" cy="6.4" r="1.7" /><circle cx="9" cy="12.4" r="1.7" /><circle cx="18.9" cy="5.6" r="2.1" fill="currentColor" stroke="none" /></Stroke>,
  Dungeon: <Stroke><path d="M4.6 20.2V11a7.4 7.4 0 0 1 14.8 0v9.2" /><path d="M2.8 20.2h18.4" /><path d="M12 3.7v16.5M4.6 12.4h14.8" opacity=".5" /><path d="M8.2 4.9v15.3M15.8 4.9v15.3" opacity=".5" /></Stroke>,
  Multiplayer: <Stroke><rect x="2.9" y="6.3" width="8.8" height="13" rx="2.2" transform="rotate(-10 7.3 12.8)" /><rect x="12.3" y="4.9" width="8.8" height="13" rx="2.2" transform="rotate(8 16.7 11.4)" /><circle cx="16.7" cy="11.4" r="1.7" fill="currentColor" stroke="none" /></Stroke>,
  Story: <Stroke><path d="M12 3.1c4.3 2.7 6.4 5.8 6.4 9.1 0 4.4-2.9 8.6-6.4 8.6s-6.4-4.2-6.4-8.6c0-3.3 2.1-6.4 6.4-9.1z" /><path d="M12 4.4 10.1 9.9l3.3 2.3-2.5 4.5 1.1 3.6" opacity=".5" /></Stroke>
};

export const ModeIcon = ({ mode }) => <span className="mode-icon">{MODE_ICONS[mode] || MODE_ICONS.Classic}</span>;

